module.exports = __webpack_public_path__ + "static/media/08.2a89d509.jpg";